import * as React from "react";
import { Button } from "@/components/ui/button";
import { Save } from "lucide-react";
import type { ChronoEntry, DocumentChronology } from "@/types/chronology";
import { toast } from "react-toastify";
import { useUpdateChronoRecordMutation } from "@/api/chronology";
import { useFormContext } from "react-hook-form";
import { ChronoEntryFormInputs } from "@/views/chronology/components/chronologyList/types";

interface Props {
  chronoRecord?: ChronoEntry;
  toggleIsEditable: () => void;
  documentChronology: DocumentChronology;
  onSave?: () => void;
}

export const ChronologyListRecordSave: React.FC<Props> = ({
  chronoRecord,
  documentChronology,
  toggleIsEditable,
  onSave,
}) => {
  const [updateChronoRecord] = useUpdateChronoRecordMutation();
  const methods = useFormContext<ChronoEntryFormInputs>();

  const handleSubmit = () => {
    methods.handleSubmit(onSubmit)();
  };

  const onSubmit = async (data: Partial<ChronoEntry>) => {
    try {
      await updateChronoRecord({
        id: chronoRecord?.id,
        data: {
          ...data,
          transaction_fse_id: chronoRecord?.fse_id || documentChronology.fse_id,
          fse_id: chronoRecord?.fse_id || documentChronology.fse_id,
          tx_id: documentChronology.tx_id,
        },
      }).unwrap();
      toast.success("Chronology saved!");
      toggleIsEditable();
      onSave?.();
    } catch (error) {
      toast.error("Error while update chronology");
      console.error("error", error);
    }
  };

  return (
    <Button variant="secondary" size="sm" className="mr-1 w-full text-xs sm:w-auto" onClick={handleSubmit}>
      <Save className="h-3 w-3" />
    </Button>
  );
};
